<div
  fxLayout="column"
  fxLayoutGap="12px">
  <mg-form-text-input
    [control]="group.get(BEHAVIOR_FIELDS.NOTE)"
    [label]="MESSAGES.FORM_LABEL_NOTE">
  </mg-form-text-input>
</div>
